import { createFileRoute, useSearch } from "@tanstack/react-router";
import { z } from "zod";
import { PreferencesPage } from "../components/preferences/PreferencesPage";

/** How connecting a Slack account went, as Slack's return to Steer said it (BUILD_SPEC §18.4). */
const preferencesSearchSchema = z.object({ slack: z.string().max(40).optional().catch(undefined) });

function PreferencesRoute() {
  const search = useSearch({ from: "/admin/preferences" });
  return <PreferencesPage slackOutcome={search.slack} />;
}

/** The person's own preferences in this workspace (BUILD_SPEC §15.4, §4.3). */
export const Route = createFileRoute("/admin/preferences")({
  validateSearch: preferencesSearchSchema,
  component: PreferencesRoute,
});
